module.exports = __webpack_public_path__ + "img/bleep-bloop-right.64342f7c.png";